import { ReactElement, ReactNode, useState } from 'react';
import classnames from 'classnames';

interface MobileNavGroupProps {
  children: ReactNode;
  hasNotification?: boolean;
  icon: ReactElement;
  name: string;
  startExpanded: boolean;
}

const MobileNavGroup = ({ children, hasNotification = false, icon, name, startExpanded }: MobileNavGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(startExpanded);

  return (
    <div className={`mobile-nav__navlink-group navlink-group-${name}`} data-testid={`mobile-nav-navlink-group-${name}`}>
      <button className="mobile-nav__navlink-group-btn" onClick={() => setIsExpanded(!isExpanded)} type="button">
        <span className="mobile-nav__navlink-icon w-6 leading-none">
          {icon}
          {hasNotification && (
            <span
              aria-hidden="true"
              className="mobile-nav__notification-dot"
              data-testid={`mobile-nav-navlink-group-${name}-notification`}
            />
          )}
        </span>
        <div className="mobile-nav__navlink-group-label">{name}</div>
        <div
          className={classnames('mobile-nav__navlink-group-indicator', {
            expanded: isExpanded,
          })}
        >
          <span className="mobile-nav__navlink-group-indicator-line" />
          <span className="mobile-nav__navlink-group-indicator-line" />
        </div>
      </button>
      {isExpanded && children}
    </div>
  );
};

export default MobileNavGroup;
